import Vue from 'vue'
import Vuex from 'vuex'
import {colleccion_documentos} from '@/FirebaseConfig'
import tipo_de_documento_comprobante from '@/jsons/tipo_de_documento_comprobante.json'
Vue.use(Vuex)
export default {
  namespaced:true,
  state: {
    registro:[]
  },
  actions: {
    obtener_todo: async ({state}) => colleccion_documentos.limit(50).onSnapshot(collection =>{
      const colección = []
      collection.docs.map(item => colección.push(item.data()))
      state.registro = colección
    }),
  },
  getters: {
    imprimir: state => {
      return state.registro.map( item => {
        return ({...item, nombre_de_comprobante: tipo_de_documento_comprobante.filter( comprobante => comprobante.value == item.tipo_de_comprobante )[0].abreviatura })
      })
    }
  }
}
  